if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          variantMap: this.querySelector('[id^="VariantMediaMap"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;

        /*
         * ---------------------------------------------------------
         * GALERIE DAWN
         * ---------------------------------------------------------
         */

        if (this.elements.thumbnails) {
          this.elements.viewer.addEventListener(
            'slideChanged',
            debounce(this.onSlideChanged.bind(this), 500)
          );

          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector('button');

              if (!button) return;

              button.addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
            });

          if (
            this.dataset.desktopLayout &&
            this.dataset.desktopLayout.includes('thumbnail') &&
            this.mql.matches
          ) {
            this.removeListSemantic();
          }
        }

        /*
         * ---------------------------------------------------------
         * TABLE VARIANTE → FEATURED MEDIA
         * ---------------------------------------------------------
         */

        this.variantMediaMap = {};

        if (this.elements.variantMap) {
          this.elements.variantMap
            .querySelectorAll('[data-variant-id]')
            .forEach((item) => {
              const variantId = item.dataset.variantId;
              const mediaId = item.dataset.variantMediaId;

              if (variantId && mediaId) {
                this.variantMediaMap[String(variantId)] =
                  String(mediaId);
              }
            });
        }

        /*
         * ---------------------------------------------------------
         * GROUPES
         * ---------------------------------------------------------
         *
         * Chaque média possède :
         *
         * data-variant-group-media-id
         *
         * Exemple :
         *
         * image commune = ""
         *
         * Petite 1 = "123456"
         * Petite 2 = "123456"
         * Petite 3 = "123456"
         *
         * Grosse 1 = "789012"
         * Grosse 2 = "789012"
         * Grosse 3 = "789012"
         */

        this.buildGroups();

        /*
         * ---------------------------------------------------------
         * ÉCOUTE DES CHANGEMENTS DE VARIANTE
         * ---------------------------------------------------------
         */

        this.setupVariantListeners();

        /*
         * ---------------------------------------------------------
         * INITIALISATION
         * ---------------------------------------------------------
         */

        setTimeout(() => {
          this.detectCurrentVariant();
        }, 0);
      }

      /*
       * ==========================================================
       * CONSTRUCTION DES GROUPES
       * ==========================================================
       */

      buildGroups() {
        this.groups = {};

        const slides = this.elements.viewer.querySelectorAll(
          '[data-media-id]'
        );

        slides.forEach((slide) => {
          const groupId =
            slide.dataset.variantGroupMediaId;

          /*
           * IMPORTANT :
           * Aucun groupId = image commune.
           *
           * Elle n'est volontairement ajoutée à aucun groupe.
           */

          if (!groupId) return;

          if (!this.groups[groupId]) {
            this.groups[groupId] = [];
          }

          this.groups[groupId].push(
            slide.dataset.mediaIdOnly
          );
        });

        /*
         * Même chose pour les miniatures.
         */

        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((thumbnail) => {
              const groupId =
                thumbnail.dataset.variantGroupMediaId;

              if (!groupId) return;

              if (!this.groups[groupId]) {
                this.groups[groupId] = [];
              }

              const mediaId =
                thumbnail.dataset.mediaIdOnly;

              if (
                mediaId &&
                !this.groups[groupId].includes(mediaId)
              ) {
                this.groups[groupId].push(mediaId);
              }
            });
        }
      }

      /*
       * ==========================================================
       * ÉCOUTE VARIANTES
       * ==========================================================
       */

      setupVariantListeners() {
        /*
         * Événement Dawn/Shopify.
         */

        document.addEventListener(
          'variant:change',
          (event) => {
            if (
              event.detail &&
              event.detail.variant
            ) {
              this.showVariant(
                event.detail.variant
              );
            }
          }
        );

        /*
         * Changements sur les sélecteurs.
         */

        const variantSelectors =
          document.querySelectorAll(
            'variant-selects, variant-radios'
          );

        variantSelectors.forEach((selector) => {
          selector.addEventListener(
            'change',
            () => {
              /*
               * Dawn doit d'abord mettre à jour
               * l'input variant ID.
               */

              setTimeout(() => {
                this.detectCurrentVariant();
              }, 50);
            }
          );
        });

        /*
         * Surveillance de l'input variant ID.
         */

        const productInfo =
          this.closest('product-info') ||
          document.querySelector('product-info');

        if (!productInfo) return;

        const variantInput =
          productInfo.querySelector(
            'input[name="id"]'
          );

        if (variantInput) {
          this.lastVariantId =
            variantInput.value;

          this.variantInputObserver =
            new MutationObserver(() => {
              const newVariantId =
                variantInput.value;

              if (
                newVariantId &&
                newVariantId !== this.lastVariantId
              ) {
                this.lastVariantId =
                  newVariantId;

                this.showVariantById(
                  newVariantId
                );
              }
            });

          this.variantInputObserver.observe(
            variantInput,
            {
              attributes: true,
              attributeFilter: ['value'],
            }
          );
        }

        /*
         * Surveillance de data-selected-variant.
         */

        const selectedVariant =
          productInfo.querySelector(
            '[data-selected-variant]'
          );

        if (selectedVariant) {
          this.selectedVariantObserver =
            new MutationObserver(() => {
              this.detectCurrentVariant();
            });

          this.selectedVariantObserver.observe(
            selectedVariant,
            {
              attributes: true,
              attributeFilter: [
                'data-selected-variant',
              ],
            }
          );
        }
      }

      /*
       * ==========================================================
       * DÉTECTION VARIANTE COURANTE
       * ==========================================================
       */

      detectCurrentVariant() {
        const productInfo =
          this.closest('product-info') ||
          document.querySelector('product-info');

        if (!productInfo) return;

        /*
         * 1. data-selected-variant
         */

        const selectedVariantElement =
          productInfo.querySelector(
            '[data-selected-variant]'
          );

        if (selectedVariantElement) {
          const json =
            selectedVariantElement.dataset
              .selectedVariant;

          if (json) {
            try {
              const variant =
                JSON.parse(json);

              if (variant && variant.id) {
                this.showVariant(variant);
                return;
              }
            } catch (error) {
              /*
               * On continue avec le fallback.
               */
            }
          }
        }

        /*
         * 2. input[name="id"]
         */

        const variantInput =
          productInfo.querySelector(
            'input[name="id"]'
          );

        if (
          variantInput &&
          variantInput.value
        ) {
          this.showVariantById(
            variantInput.value
          );
        }
      }

      /*
       * ==========================================================
       * AFFICHER VARIANTE
       * ==========================================================
       */

      showVariant(variant) {
        if (!variant || !variant.id) return;

        let mediaId = null;

        /*
         * Si Shopify fournit directement featured_media.id,
         * on l'utilise.
         */

        if (
          variant.featured_media &&
          variant.featured_media.id
        ) {
          mediaId =
            String(variant.featured_media.id);
        }

        /*
         * Sinon on utilise notre table Liquid.
         */

        if (!mediaId) {
          mediaId =
            this.variantMediaMap[
              String(variant.id)
            ];
        }

        if (!mediaId) return;

        this.showGroup(mediaId);
      }

      /*
       * ==========================================================
       * AFFICHER PAR ID DE VARIANTE
       * ==========================================================
       */

      showVariantById(variantId) {
        if (!variantId) return;

        const mediaId =
          this.variantMediaMap[
            String(variantId)
          ];

        if (!mediaId) return;

        this.showGroup(mediaId);
      }

      /*
       * ==========================================================
       * AFFICHER UN GROUPE
       * ==========================================================
       */

      showGroup(groupId) {
        groupId = String(groupId);

        const group =
          this.groups[groupId];

        if (!group || !group.length) {
          return;
        }

        const allowed =
          new Set(group);

        /*
         * -------------------------------------------------------
         * MÉDIAS PRINCIPAUX
         * -------------------------------------------------------
         */

        this.elements.viewer
          .querySelectorAll(
            '[data-media-id]'
          )
          .forEach((slide) => {
            const mediaId =
              slide.dataset.mediaIdOnly;

            const visible =
              allowed.has(
                String(mediaId)
              );

            slide.hidden = !visible;

            slide.classList.toggle(
              'variant-media-hidden',
              !visible
            );
          });

        /*
         * -------------------------------------------------------
         * MINIATURES
         * -------------------------------------------------------
         */

        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll(
              '[data-target]'
            )
            .forEach((thumbnail) => {
              const mediaId =
                thumbnail.dataset.mediaIdOnly;

              const visible =
                allowed.has(
                  String(mediaId)
                );

              thumbnail.hidden = !visible;

              thumbnail.classList.toggle(
                'variant-thumbnail-hidden',
                !visible
              );
            });
        }

        /*
         * -------------------------------------------------------
         * TROUVER LA PREMIÈRE IMAGE DU GROUPE
         * -------------------------------------------------------
         */

        const firstMediaId =
          group[0];

        const firstSlide =
          this.elements.viewer.querySelector(
            `[data-media-id-only="${CSS.escape(
              String(firstMediaId)
            )}"]`
          );

        if (!firstSlide) return;

        /*
         * -------------------------------------------------------
         * ACTIVER LA PREMIÈRE IMAGE
         * -------------------------------------------------------
         */

        this.elements.viewer
          .querySelectorAll(
            '[data-media-id]'
          )
          .forEach((slide) => {
            slide.classList.remove(
              'is-active'
            );
          });

        firstSlide.classList.add(
          'is-active'
        );

        /*
         * -------------------------------------------------------
         * ACTIVER LA MINIATURE
         * -------------------------------------------------------
         */

        if (this.elements.thumbnails) {
          const thumbnail =
            this.elements.thumbnails.querySelector(
              `[data-media-id-only="${CSS.escape(
                String(firstMediaId)
              )}"]`
            );

          if (thumbnail) {
            this.setActiveThumbnail(
              thumbnail
            );
          }
        }

        /*
         * -------------------------------------------------------
         * RESET SLIDERS
         * -------------------------------------------------------
         */

        if (
          this.elements.viewer.slider
        ) {
          this.elements.viewer.resetPages();
        }

        if (
          this.elements.thumbnails &&
          this.elements.thumbnails.slider
        ) {
          this.elements.thumbnails.resetPages();
        }

        /*
         * -------------------------------------------------------
         * SCROLL VERS L'IMAGE
         * -------------------------------------------------------
         */

        setTimeout(() => {
          if (
            !this.mql.matches ||
            this.elements.thumbnails
          ) {
            firstSlide.parentElement.scrollTo({
              left: firstSlide.offsetLeft,
            });
          }
        }, 20);

        this.playActiveMedia(
          firstSlide
        );
      }

      /*
       * ==========================================================
       * CLIC SUR MINIATURE
       * ==========================================================
       */

      setActiveMedia(
        mediaId,
        prepend
      ) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${CSS.escape(
              mediaId
            )}"]`
          );

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll(
            '[data-media-id]'
          )
          .forEach((element) => {
            element.classList.remove(
              'is-active'
            );
          });

        activeMedia.classList.add(
          'is-active'
        );

        if (prepend) {
          activeMedia.parentElement.prepend(
            activeMedia
          );

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${CSS.escape(
                  mediaId
                )}"]`
              );

            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );
            }
          }

          if (
            this.elements.viewer.slider
          ) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        setTimeout(() => {
          if (
            !this.mql.matches ||
            this.elements.thumbnails
          ) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
        });

        this.playActiveMedia(
          activeMedia
        );

        if (!this.elements.thumbnails) {
          return;
        }

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${CSS.escape(
              mediaId
            )}"]`
          );

        this.setActiveThumbnail(
          activeThumbnail
        );

        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }
      }

      /*
       * ==========================================================
       * SLIDE CHANGÉ
       * ==========================================================
       */

      onSlideChanged(event) {
        if (
          !this.elements.thumbnails
        ) {
          return;
        }

        const currentElement =
          event.detail.currentElement;

        if (!currentElement) return;

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${CSS.escape(
              currentElement.dataset.mediaId
            )}"]`
          );

        this.setActiveThumbnail(
          thumbnail
        );
      }

      /*
       * ==========================================================
       * MINIATURE ACTIVE
       * ==========================================================
       */

      setActiveThumbnail(thumbnail) {
        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {
          return;
        }

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((button) => {
            button.removeAttribute(
              'aria-current'
            );
          });

        const button =
          thumbnail.querySelector('button');

        if (!button) return;

        button.setAttribute(
          'aria-current',
          'true'
        );

        if (
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {
          return;
        }

        if (
          this.elements.thumbnails.slider
        ) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
          });
        }
      }

      /*
       * ==========================================================
       * ACCESSIBILITÉ
       * ==========================================================
       */

      announceLiveRegion(
        activeItem,
        position
      ) {
        if (
          !this.elements.liveRegion
        ) {
          return;
        }

        const image =
          activeItem.querySelector(
            '.product__modal-opener--image img'
          );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            'false'
          );

          if (
            window.accessibilityStrings &&
            window.accessibilityStrings.imageAvailable
          ) {
            this.elements.liveRegion.innerHTML =
              window.accessibilityStrings.imageAvailable.replace(
                '[index]',
                position
              );
          }

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              'true'
            );
          }, 2000);
        };

        image.src = image.src;
      }

      /*
       * ==========================================================
       * VIDÉOS / MÉDIAS
       * ==========================================================
       */

      playActiveMedia(activeItem) {
        if (
          typeof window.pauseAllMedia ===
          'function'
        ) {
          window.pauseAllMedia();
        }

        const deferredMedia =
          activeItem.querySelector(
            '.deferred-media'
          );

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      /*
       * ==========================================================
       * HEADER STICKY
       * ==========================================================
       */

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector(
            'sticky-header'
          );

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event(
            'preventHeaderReveal'
          )
        );
      }

      /*
       * ==========================================================
       * ACCESSIBILITÉ SLIDER
       * ==========================================================
       */

      removeListSemantic() {
        if (
          !this.elements.viewer.slider
        ) {
          return;
        }

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach(
          (slide) => {
            slide.setAttribute(
              'role',
              'presentation'
            );
          }
        );
      }
    }
  );
}
